export const RECENTLY_VIEWED_URL = `/api/border-control/users/recently-viewed`;
